import React from 'react'
import { IconBrandFacebookFilled, IconBrandGoogleFilled } from '@tabler/icons-react'
import { useAuth } from '../../../Auth/AuthProvider'
import { useNavigate } from 'react-router-dom'
import Spinner from '../../../Components/Spinner'

const providerStyles = {
  facebook: 'bg-facebook hover:brightness-95',
  google: 'bg-google hover:brightness-95',
}

const providerIcons = {
  facebook: IconBrandFacebookFilled,
  google: IconBrandGoogleFilled,
}

export default function LoginOther(props) {
  const { loginWithProvider } = useAuth()
  const navigate = useNavigate()
  const ProviderIcon = providerIcons[props.variation]

  const signIn = () => {
    props.handleLogin(props.variation, true)
    loginWithProvider(props.variation)
      .then(() => {
        props.handleLogin(props.variation, false)
        navigate(props.userHomePath)
      })
      .catch((err) => {
        props.handleLogin(props.variation, false)
        props.handleError(props.variation, err.message)
      })
  }

  return (
    <div>
      <button
        type="button"
        className={`flex w-full items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-white transition ${providerStyles[props.variation] || 'bg-mauve-700'} ${props.className || ''}`}
        onClick={(e) => {
          e.preventDefault()
          signIn()
        }}
      >
        {props.loggingIn ? (
          <Spinner className="text-white" />
        ) : (
          <>
            {ProviderIcon ? <ProviderIcon className="size-4" /> : null}
            {props.text}
          </>
        )}
      </button>
      {props.error ? (
        <p className="mt-2 text-sm text-red-600">{props.error}</p>
      ) : null}
    </div>
  )
}
